import { LocalDictionaryFactory, Api } from '../../api/api.module'

import { Enums } from '../../../models/common/enums'

import {
    DISTRIBUTOR_EXTENDED_PARAMETERS_SERVICE_NAME,
    DISTRIBUTOR_HIERARCHY_SERVICE_NAME,
    DISTRIBUTOR_SERVICE_NAME,
    DISTRIBUTOR_SUPPLIER_SERVICE_NAME,
    DistributorExtendedParametersService,
    DistributorHierarchyService,
    DistributorService,
    DistributorSupplierService,
} from '../../../services/distributor'

import { $SCOPE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, $Q_SERVICE_NAME } from '../../../services/system'
import { UserSessionService, USER_SESSION_SERVICE_NAME } from '../../../services/user-session'
import { } from '../../../services/distributor/distributor.hierarchy.service'

import { DistributorDetailsDirectiveController } from './distributor-details.directive.controller'

//#region Asset Imports

import * as TEMPLATE from './distributor-details.tpl.html'

//#endregion

export class DistributorDetailsDirective implements ng.IDirective {
    restrict = 'E'

    scope = {
        id: '='
    }

    controller = [
        $SCOPE_SERVICE_NAME,
        $Q_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        'api',
        'localDictionary',
        DISTRIBUTOR_SERVICE_NAME,
        DISTRIBUTOR_EXTENDED_PARAMETERS_SERVICE_NAME,
        DISTRIBUTOR_HIERARCHY_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        DISTRIBUTOR_SUPPLIER_SERVICE_NAME, (
            $scope,
            $q: ng.IQService,
            $timeout: ng.ITimeoutService,
            api: Api,
            localDictionary: LocalDictionaryFactory,
            distributorService: DistributorService,
            distributorExtendedParametersService: DistributorExtendedParametersService,
            distributorHierarchyService: DistributorHierarchyService,
            userSessionService: UserSessionService,
            distributorSupplierService: DistributorSupplierService,
        ) => {
            return new DistributorDetailsDirectiveController(
                $scope,
                $q,
                $timeout,
                api,
                localDictionary,
                distributorService,
                distributorExtendedParametersService,
                distributorHierarchyService,
                userSessionService,
                distributorSupplierService,
                Enums.ReferenceType.IdDistributor,
                Enums.SimaxModuleName.Distributor
            )
        }]

    controllerAs = '$ctrl'

    template = TEMPLATE
}